export default "__VITE_ASSET__CG$gpVON__"